<template>
  <div class="cooperation">
    <div class="title">{{ $t('common.cooperTip') }}</div>
    <div class="info hidden-sm-and-down">{{ $t('common.cooperConsultPhone')+'：'+$t('common.phone')+' '+$t('common.principal')+'：'+$t('common.MrXie') }}</div>
    <div class="info hidden-md-and-up">
      <div> {{ $t('common.cooperConsultPhone')+'：'+$t('common.phone') }}</div>
      <div>{{ $t('common.principal')+'：'+$t('common.MrXie') }}</div>
    </div>
    <avue-form v-model="form"
               :option="option"
               @submit="submit" />
  </div>

</template>

<script>
import { formOption } from '@/const/crud/common'
import { commonApi } from '@/api/commonApi'

export default {
  name: 'Cooperation',
  data() {
    return {
      form: {},
      option: formOption
    }
  },
  methods: {
    async submit(from, done) {
      try {
        await commonApi.applyCooperation(from)
        this.$message.success(this.$t('common.operateSucc'))
        this.$router.go(-1)
        done()
      } catch (err) {
        done()
        console.error(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  margin-top: 20px;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  font-weight: bold;
  text-align: center;
}

.info {
  margin-top: 20px;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  background: #f9f9f9;
  height: 80px;
  line-height: 40px;
}

/deep/ .avue-form {
  padding-top: 30px;
}
</style>
